module.exports = ".spacediv{\n    margin-top: 4px;\n}\n\n.text-nowrap {\n    white-space: nowrap !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/broker/broker-audit-declaration/section3-ba-data-residential-prop-mgmt/section3-ba-data-residential-prop-mgmt.component.css
// module id = ./src/app/broker/broker-audit-declaration/section3-ba-data-residential-prop-mgmt/section3-ba-data-residential-prop-mgmt.component.css
// module chunks = main